import { render, staticRenderFns } from "./WarningsSettings.vue?vue&type=template&id=c5c680d2&scoped=true"
import script from "./WarningsSettings.vue?vue&type=script&lang=js"
export * from "./WarningsSettings.vue?vue&type=script&lang=js"
import style0 from "./WarningsSettings.vue?vue&type=style&index=0&id=c5c680d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c680d2",
  null
  
)

export default component.exports